import React, { useEffect } from 'react'
import { Container } from '@material-ui/core'
import styleClasses from '../components/common/common.module.scss'
import useDoorbellsApi from '../hooks/doorbells/useDoorbellsApi'
import CustomTable from '../components/customTable/CustomTable'

export default function DoorbellsPage() {
  const [
    { doorbellsState },
    { getDoobellSchedules, cleanOneTime, cleanConcurrents },
  ] = useDoorbellsApi()

  useEffect(() => {
    const fetchData = async () => {
      getDoobellSchedules()
    }
    fetchData()
  }, [])

  const columns = [
    {
      id: 'name',
      label: 'Nombre',
      minWidth: 120,
      order: 6,
      format: (data) => <div>{data?.doorbell.name}</div>,
    },
    {
      id: 'building',
      label: 'Edificio',
      format: (data) => <div>{data?.doorbell?.building?.name}</div>,
    },
    {
      id: 'schedules',
      label: 'Total schedules',
      format: (data) => <div>{data?.schedules?.count}</div>,
    },
    {
      id: 'expired',
      label: 'One time expirados',
      format: (data) => <div>{data?.expired?.count}</div>,
    },
    {
      id: 'recurringAlldays',
      label: 'Recurrentes todos los días',
      format: (data) => <div>{data?.recurringAlldays?.count}</div>,
    },
    {
      id: '',
      label: '',
      minWidth: 5,
    },
  ]

  const options = (data) => [
    {
      key: 'edit',
      label: 'Borrar one time expirados',
      onClick: () => {
        if (data?.doorbell?.id) {
          cleanOneTime(data?.doorbell?.id)
        }
      },
    },
    {
      key: 'updateImages',
      label: 'Recurrentes (L a D) a permanentes',
      onClick: () => {
        if (data?.doorbell?.id) {
          cleanConcurrents(data?.doorbell?.id)
        }
      },
    },
  ]

  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <CustomTable
          loading={doorbellsState.isLoading}
          columns={columns}
          data={doorbellsState.doorbells || []}
          getData={(params) => {
            getDoobellSchedules()
          }}
          buildingFilter={false}
          building={false}
          apartmentFilter={false}
          searchFilter={'Nombre'}
          searchTitle="Nombre"
          searchPlaceholder="Nombre"
          serverPagination={false}
          serverCount={doorbellsState.doorbells?.length}
          options={options}
        ></CustomTable>
      </Container>
    </main>
  )
}
